/**
 * Generated Icon Classes
 *
 * This file contains individual icon classes for all available SVG icons.
 * Each class extends BaseIcon and provides a convenient way to create
 * specific icons with predefined settings.
 */

import BaseIcon from './BaseIcon.js';

const optionsDefaults = {
  color: 'currentColor',
  strokeColor: null,
  size: 16,
  className: '',
};

export class DotsVerticalIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('dots-vertical', options);
  }
}

// 360 Icon
export class Icon360 extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('360', options);
  }
}

// AI Icons
export class AiIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('ai', options);
  }
}

export class AiSparkIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('ai-spark', options);
  }
}

// Arrow Icons
export class ArrowUpIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('arrow-up', options);
  }
}

// Auction Icon
export class AuctionIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('auction', options);
  }
}

// Blueprint Icon
export class BlueprintIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('blueprint', options);
  }
}

// Bookmark Icon
export class BookmarkIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('bookmark', options);
  }
}

// Bot Icon
export class BotIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('bot', options);
  }
}

// Brush Icon
export class BrushIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('brush', options);
  }
}

// Calendar Icons
export class CalendarIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('calendar', options);
  }
}

export class CalendarOneIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('calendar-one', options);
  }
}

export class CalendarPlusIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('calendar-plus', options);
  }
}

// Camera Icon
export class CameraIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('camera', options);
  }
}

export class CanvasIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('canvas', options);
  }
}

// Check Icons
export class CheckIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('check', options);
  }
}
export class CheckCheckIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('check-check', options);
  }
}

export class CircleCheckMarkIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('circle-check-mark', options);
  }
}

// Cross Icon
export class CircleCrossIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('circle-cross', options);
  }
}

// Info Icons
export class CircleInfoMessageIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('circle-info-message', options);
  }
}

// Warning Icon
export class CircleWarningIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('circle-warning', options);
  }
}

// Coins Icon
export class CoinsIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('coins', options);
  }
}

// Collapse Icons
export class CollapseIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('collapse', options);
  }
}

export class CollapsePreviewIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('collapse-preview', options);
  }
}

// Columns Icon
export class ColumnsIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('columns', options);
  }
}

// Comment Icons
export class CommentIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('comment', options);
  }
}

export class CommentTextIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('comment-text', options);
  }
}

// Copy Icon
export class CopyIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('copy', options);
  }
}

// Decimals Arrow Left Icon
export class DecimalsArrowLeftIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('decimals-arrow-left', options);
  }
}

// Trash Icons
export class TrashIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('trash', options);
  }
}

export class DeleteFileIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('delete-file', options);
  }
}

// Download Icon
export class DownloadIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('download', { color: 'none', ...options });
  }
}
export class UploadIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('upload', { color: 'none', ...options });
  }
}

// Dropdown Icon
export class DropdownIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('dropdown', options);
  }
}

// Due Date Icon
export class DueDateIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('duedate', options);
  }
}

// Edit Icon
export class EditIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('edit', options);
  }
}

// Eraser Icon
export class EraserIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('eraser', options);
  }
}

// Expand Icons
export class ExpandIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('expand', options);
  }
}

export class ExpandPreviewIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('expand-preview', options);
  }
}

// Eye Icons
export class EyeClosedIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('eye-closed', options);
  }
}

export class EyeOpenIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('eye-open', options);
  }
}
export class ScanEyeIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('scan-eye', options);
  }
}

// Factory Icon
export class FactoryIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('factory', options);
  }
}

// Building Icon
export class BuildingIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('building', options);
  }
}

// File Icon
export class FileIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('file', options);
  }
}
export class DataIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('data', options);
  }
}

// Filter Icon
export class FilterIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('filter', options);
  }
}

// Folder Icon
export class FolderIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('folder', options);
  }
}
export class FolderPlusIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('folder-plus', options);
  }
}
export class FolderSyncIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('folder-sync', options);
  }
}

// Globe Icon
export class GlobeIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('globe', options);
  }
}

// Grid Icon
export class GridIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('grid', options);
  }
}

// Handshake Icon
export class HandshakeIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('handshake', options);
  }
}

// Light/Dark Mode Icon
export class IconLightDarkIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('light-dark', options);
  }
}

// Image Icon
export class ImageIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('image', options);
  }
}

// Interact Icon
export class InteractIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('interact', options);
  }
}

// Light Icons
export class LightOffIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('light-off', options);
  }
}

export class LightOnIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('light-on', options);
  }
}

export class LightsIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('lights', options);
  }
}

// Lightbulb Icon
export class LightbulbBottomIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('lightbulb-bottom', options);
  }
}

// Line Icons
export class LineRulerIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('line-ruler', options);
  }
}

export class LineThicknessIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('line_thickness', options);
  }
}

// List Icon
export class ListIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('list', options);
  }
}
export class ListOrderedIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('list-ordered', options);
  }
}
export class ListPlusIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('list-plus', options);
  }
}
export class ListChecksIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('list-checks', options);
  }
}

// Logout Icon
export class LogoutIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('logout', { color: 'none', ...options });
  }
}

// Mail Icon
export class MailIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('mail', options);
  }
}

export class MailReadIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('mail-read', options);
  }
}

export class GroupIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('group', options);
  }
}

// Model Icons
export class ModelIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('model', options);
  }
}

// Mountain Icon
export class MountainIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('mountain', options);
  }
}

// Move Icon
export class MoveIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('move', options);
  }
}
export class MoveFileIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('move-file', options);
  }
}

// Night Icon
export class NightIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('night', options);
  }
}

// Notification Icons
export class NotificationIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('notification', options);
  }
}
export class NotificationOffIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('notification-off', options);
  }
}

// Opacity Icon
export class OpacityIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('opacity', options);
  }
}

// Order Icons
export class OrderIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('order', options);
  }
}

export class OrdersIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('orders', options);
  }
}

// Paint Icon
export class PaintIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('paint', options);
  }
}

// Panorama Icon
export class PanoramaIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('panorama', options);
  }
}

// PDF Icons
export class PdfIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('pdf', options);
  }
}

// Pen Icons
export class PenIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('pen', options);
  }
}

// Pen Line Icons
export class PenLineIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('pen-line', options);
  }
}

// Scribble Icons
export class Scribble extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('scribble', options);
  }
}

// Plus Icon
export class PlusIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('plus', options);
  }
}
export class PlusRoundedIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('plus-rounded', options);
  }
}

// Project Icons
export class ProjectIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('project', options);
  }
}

export class ProjectsIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('projects', options);
  }
}

// Reply Icon
export class ReplyIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('reply', options);
  }
}

// Report Icon
export class ReportIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('report', options);
  }
}

// Reset Icon
export class ResetIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('reset', options);
  }
}

// Scale Icon
export class ScaleIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('scale', options);
  }
}
export class MeasureScaleIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('measure-scale', options);
  }
}

// Settings Icon
export class SettingsIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('settings', options);
  }
}

// Share Icon
export class ShareIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('share', options);
  }
}
export class Share2Icon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('share-2', options);
  }
}

// Square Menu Icon
export class SquareMenuIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('square-menu', options);
  }
}

export class BurgerMenuIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('burger-menu', options);
  }
}
// Subscription Icon
export class SubscriptionIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('subscription', options);
  }
}

// Tag Distance Icon
export class TagDistanceIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('tag-distance', options);
  }
}

// Type Icon
export class TypeIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('type', options);
  }
}

// Undo Icon
export class UndoIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('undo', options);
  }
}
export class RedoIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('redo', options);
  }
}

// User Icon
export class UserIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('user', options);
  }
}
export class UsersIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('users', options);
  }
}
export class UserCircleIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('user-circle', options);
  }
}

// Video Icons
export class VideoIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('video', options);
  }
}

// X Icon
export class XIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('X', options);
  }
}
export class XCircleIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('x-circle', options);
  }
}

export class SearchIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('search', options);
  }
}

export class AtIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('@', options);
  }
}

export class PaperClipIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('paperclip', options);
  }
}

export class ChevronIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('chevron', options);
  }
}

export class SaveIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('save', options);
  }
}

export class HistoryIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('history', options);
  }
}
export class ArrowLeftIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('arrow-left', options);
  }
}

export class ZipFileIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('zip-file', options);
  }
}
export class CsvFileIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('csv-file', options);
  }
}
export class PlayIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('play', options);
  }
}
export class TagIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('tag', options);
  }
}

export class ToolsIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('tools', options);
  }
}
export class RotateIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('rotate', options);
  }
}
export class MousePointerIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('mouse-pointer', options);
  }
}
export class MeasureIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('measure', options);
  }
}
export class ThreeDTopIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('box-top', options);
  }
}
export class ThreeDFrontIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('box-left', options);
  }
}
export class ThreeDRightIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('box-right', options);
  }
}
export class ThreeDRearIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('box-back', options);
  }
}
export class CropIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('crop', options);
  }
}
export class VolumeIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('volume', options);
  }
}

export class BinocularsIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('binoculars', options);
  }
}

export class SquaresIntersectIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('squares-intersect', options);
  }
}

export class SquaresSubstractIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('squares-substract', options);
  }
}
export class FocusIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('focus', options);
  }
}
export class PrinterIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('printer', options);
  }
}
export class AddIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('add', options);
  }
}
export class ClockIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('clock', options);
  }
}

export class LinkIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('link', options);
  }
}
export class FacebookIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('facebook', options);
  }
}
export class InstagramIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('instagram', options);
  }
}
export class LinkedinIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('linkedin', options);
  }
}
export class YoutubeIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('youtube', options);
  }
}
export class TiktokIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('tiktok', options);
  }
}

export class WarningIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('warning', options);
  }
}

export class BlueLeftArrowIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('blue-left-arrow', options);
  }
}

export class DescendingIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('descending', options);
  }
}

export class AscendingIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('ascending', options);
  }
}

export class HashIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('hash', options);
  }
}
export class GripIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('grip', options);
  }
}

//label icon
export class LabelIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('label', options);
  }
}
export class HeartIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('heart', options);
  }
}

export class SmileIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('smile', options);
  }
}
export class LassoIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('lasso', options);
  }
}

export class BoxIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('box', options);
  }
}

export class PovIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('pov', options);
  }
}
export class BanIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('ban', options);
  }
}
export class MicIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('mic', options);
  }
}
export class TableIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('table', options);
  }
}
export class ChannelPlusIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('channel-plus', options);
  }
}
export class MessageSquarePlusIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('message-square-plus', options);
  }
}
export class LockIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('lock', options);
  }
}
export class RefreshCwIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('refresh-cw', options);
  }
}
export class BoldIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('bold', options);
  }
}
export class ItalicIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('italic', options);
  }
}
export class CodeIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('code', options);
  }
}
export class StrikethroughIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('strikethrough', options);
  }
}
export const TextQuoteIcon = class extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('text-quote', options);
  }
};

// Google Icon (uses official Google brand colors - do not modify colors)
export class GoogleIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('google', { color: 'none', ...options });
  }
}

// HubSpot Icon (uses official HubSpot brand color - #ff7a59)
export class HubSpotIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('hubspot', { color: '#ff7a59', ...options });
  }
}

export class ShoppingCartIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('shopping-cart', options);
  }
}

export class PackageIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('package', options);
  }
}
export const WorkflowIcon = class extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('workflow', options);
  }
};
export class TargetIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('target', options);
  }
}
export class ZapIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('zap', options);
  }
}
export class SequenceIcon extends BaseIcon {
  constructor(options = optionsDefaults) {
    super('sequence', options);
  }
}
